module.exports = __webpack_public_path__ + "img/step-title.00ed3cec.png";